import { FunctionComponent } from 'react';
import { useSelector, useDispatch } from '@cbridge-utils/react-redux';
import { ClearFilterButton } from '@cbridge-tools/filters-panel';
import { selectedSymbolMappingFilterSelector } from '../../_selectors/selectedSymbolMappingFilter.selector';
import { SymbolMappingFilterAction } from '../../symbolMappingFilter.action';

export const ClearSymbolMappingFilterButton: FunctionComponent = () => {
  const dispatch = useDispatch();
  const selectedFilter = useSelector(selectedSymbolMappingFilterSelector);

  const handleClearFilter = () => {
    dispatch(SymbolMappingFilterAction.clearFilter());
  };

  return (
    <ClearFilterButton isShown={selectedFilter !== undefined} onClick={handleClearFilter} />
  );
};
